import './Styles.scss';

class NewsFilter {

    constructor(form) {
        this.form = form
        this.inputs = form.querySelectorAll('.form-check-input')
        let isCheckedOnLoad = false

        // Init event listeners
        this.inputs.forEach(input => {
            input.addEventListener('change', this.handleInputChange)

            if (input.checked) {
                isCheckedOnLoad = true
            }
        })

        if (isCheckedOnLoad) {
            this.handleInputChange()
        }
    }

    handleInputChange = () => {
        this.toggleOverlay()
        this.submitForm()
    }

    submitForm = () => {
        let data = new FormData(this.form)
        let XMLHttp = new XMLHttpRequest();

        XMLHttp.onreadystatechange = () => {
            if (XMLHttp.readyState === XMLHttpRequest.DONE && XMLHttp.status === 200) {
                let response = JSON.parse(XMLHttp.responseText)

                document.getElementById('newsList').innerHTML = response.news
            }
        }

        XMLHttp.addEventListener('loadend', () => {
            this.toggleOverlay()
        })

        data.append('action', 'news_filter')

        XMLHttp.open('POST', ajaxURL, true)
        XMLHttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
        XMLHttp.send(new URLSearchParams(data).toString())
    }

    toggleOverlay = () => {
        let dropdowns = this.form.querySelectorAll('.multiselect__dropdown')

        dropdowns.forEach(function(dropdown) {
            dropdown.classList.toggle('loading-overlay')
        })
    }
}

window.addEventListener('load', function() {
    const newsFilters = document.querySelectorAll('.news-filter')

    Array.from(newsFilters).forEach((form, index) => {
        new NewsFilter(form)
    })
})